import request from '../helpers/request';

const sendCommentToRequest = async (requestId, data, errMsg) => {
  return await request.post(
    `/Request/add_new_note/${requestId}`,
    data,
    errMsg || 'При отправке комментария произошла ошибка'
  );
};

export default sendCommentToRequest;
